import React from "react";
import { useTranslation } from "react-i18next";
import TrueFalse from "./types/TrueFalse";
import McqSingle from "./types/McqSingle";
import Matching from "./types/Matching";

const RENDERERS = {
  true_false: TrueFalse,
  mcq_single: McqSingle,
  matching: Matching,
};

// One question with its answer inputs. In review mode it shows a
// correct/incorrect badge (per-question result from the backend).
const QuestionCard = ({ index, question, value, onChange, review, correct }) => {
  const { t, i18n } = useTranslation();
  const Renderer = RENDERERS[question.type];
  if (!Renderer) return null;

  const num =
    i18n.language === "ar" ? (index + 1).toLocaleString("ar-EG") : index + 1;

  return (
    <div className="bg-grey/40 border border-lightGrey rounded-xl p-4 sm:p-5">
      <div className="flex items-start justify-between gap-3 mb-4">
        <h4 className="text-white font-medium">
          <span className="text-lightWhite text-sm">
            {t("quiz.question")} {num}.{" "}
          </span>
          {question.text}
        </h4>
        {review && (
          <span
            className={`shrink-0 text-xs font-semibold px-2.5 py-1 rounded-full ${
              correct
                ? "bg-green-500/15 text-green-400"
                : "bg-primary/15 text-primary"
            }`}
          >
            {correct ? t("quiz.correct") : t("quiz.incorrect")}
          </span>
        )}
      </div>
      <Renderer
        question={question}
        value={value}
        onChange={onChange}
        review={review}
        correct={correct}
      />
    </div>
  );
};

export default QuestionCard;
